import { PanelComponent } from './panel.component';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [PanelComponent],
  imports: [MatExpansionModule],
  exports: [PanelComponent],
  providers: [],
})
export class PanelModule {}
